import React from 'react';

import { Icon } from '@components/Icon';

const InfoMessage: React.FC<{ message: string }> = ({ message }) => (
  <div className="flex items-center flex-1" data-testid="info-message">
    <Icon
      color="gray-400"
      name="circles/notification"
      size="16"
      className="flex-shrink-0 mt-1 mr-2 self-start desktop:m-0 desktop:self-auto"
    />
    <span className="ml-1 text-xs leading-md">{message}</span>
  </div>
);

export default InfoMessage;
